export enum ConfigLevelType {
  AGENCY = <any>'AGENCY',
  BRAND = <any>'BRAND',
  CHAIN = <any>'CHAIN',
  PROPERTY = <any>'PROPERTY',
  SYSTEM = <any>'SYSTEM',
  UNKNOWN = <any>'UNKNOWN'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/config/config-level-type.ts